// extracted by mini-css-extract-plugin
export default {"title":"style_title__A8JfH","categoryItem":"style_categoryItem__X29Fz","imgBlock":"style_imgBlock__ep6oN","activeCategory":"style_activeCategory__CycDi"};